import { Dispatch, SetStateAction } from "react";
import { useMutation } from "react-query";
import { cardProcess } from "./gateway";
import { useLocation, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { useAuth } from "src/shared/context/useAuth";

function useSubmitCreditCardMutation(
  setDialog3DSOpen: Dispatch<SetStateAction<boolean>>,
  setIframeContent: Dispatch<SetStateAction<string>>,
  setEnableMerchantRef: Dispatch<SetStateAction<boolean>>,
  setEnableParesPoll: Dispatch<SetStateAction<boolean>>,
  setIsAcsChallenge: Dispatch<SetStateAction<boolean>>,
  relatedId?: string,
  relatedType?: string,
) {
  const navigate = useNavigate();
  const location = useLocation();
  const { userHomePath } = useAuth();
  return useMutation({
    mutationKey: ["submitCreditCard"],
    mutationFn: (data: any) => {
      const formData = new FormData();
      formData.append("m02_id", data.m02_id);
      formData.append("CVV", data.CVV);
      formData.append("address", data.address);
      formData.append("cardNumber", data.cardNumber);
      formData.append("cardType", data.cardType.value);
      formData.append("city", data.city);
      formData.append("countryCode", data.countryCode.value);
      formData.append("countrySubdivision", data.countryState.value);
      formData.append("customerName", data.customerName);
      formData.append("email", data.email);
      formData.append("expMonth", data.expMonth.value);
      formData.append("expYear", data.expYear.value);
      formData.append("homephone", data.homePhone);
      formData.append("mobilephone", data.mobilePhone);
      formData.append("navigatorJavaEnabled", data.navigatorJavaEnabled);
      formData.append("navigatorJsEnabled", data.navigatorJsEnabled);
      formData.append("navigatorLanguage", data.navigatorLanguage);
      formData.append("phoneCode", data.phoneCode);
      formData.append("screenColorDepth", data.screenColorDepth);
      formData.append("screenHeight", data.screenHeight);
      formData.append("screenWidth", data.screenWidth);
      formData.append("timezoneOffset", data.timezoneOffset);
      formData.append("zipCode", data.zipCode);
      if (relatedId) {
        formData.append("relatedId", relatedId);
      }
      if (relatedType) {
        formData.append("relatedType", relatedType);
      }
      return cardProcess(formData);
    },
    onSuccess: (data) => {
      if (data?.data?.tdsMethodContent) {
        setEnableMerchantRef(true);
      }
      if (data?.data?.acsFormdata) {
        // ACS challenge shown: render it in a real iframe and poll the public tdsParesValidation
        // result, then complete the sale.
        setIsAcsChallenge(true);
        setEnableParesPoll(true);
      }
      if (data?.data.tdsMethodContent || data?.data?.acsFormdata) {
        setDialog3DSOpen(true);
        setIframeContent(
          data?.data?.tdsMethodContent ?? data?.data?.acsFormdata,
        );
      } else if (data?.data?.approvalCode) {
        navigate("/cardPayment/successPayment", {
          state: {
            invoiceFileName: data?.data?.invoiceFileName,
            approvalCode: data?.data?.approvalCode,
            relatedId: relatedId,
            relatedType: relatedType,
          },
        });
      }
    },
    onError: (data: AxiosError<string>) => {
      if (data?.response?.status === 403) {
        enqueueSnackbar(data?.response?.data, {
          variant: "error",
        });
        navigate(userHomePath);
      } else {
        enqueueSnackbar(data?.response?.data, {
          variant: "error",
        });
      }
    },
  });
}

export default useSubmitCreditCardMutation;
